import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

interface DetailItemProps {
  label: string;
  value: string | number;
}

export const DetailItem: FC<DetailItemProps> = ({ label, value }) => (
  <Stack spacing={0}>
    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
      {label}
    </Typography>
    <Typography variant="body1">{value}</Typography>
  </Stack>
);
